import { render, staticRenderFns } from "./MyDetailsView.vue?vue&type=template&id=41dd5f6c&scoped=true&"
import script from "./MyDetailsView.vue?vue&type=script&lang=js&"
export * from "./MyDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./MyDetailsView.vue?vue&type=style&index=0&id=41dd5f6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dd5f6c",
  null
  
)

export default component.exports